var TECL_TenderSimpleProductSelection = {

  // Initialise the Tenders Products Selection page
  Initialise: function () {
    TECL_TenderGeneral.HidePleaseWaitDlg();

    window.scrollTo(0, 0);

    // Update the progress bar
    TECL_TenderGeneral.UpdateProgressBar(0);

    TECL_TenderProductsSelection.FormatBudgetOnChange();

    // Handle card selection
    $("#categoryCards").find(".categoryCard").click(function () {
      var categoryId = $(this).attr("data-categoryId");
      var categoryName = $(this).attr("data-categoryName");
      var subCategoryId = $(this).attr("data-subCategoryId");
      var subCategoryTagMapId = $(this).attr("data-subCategoryTagMapId");

      if (categoryId && subCategoryId && subCategoryTagMapId) {
        // Store selected category info and show the product info section 
        $("#selectedCategoryId").val(categoryId);
        $("#selectedCategoryName").val(categoryName);
        $("#selectedSubCategoryId").val(subCategoryId);
        $("#selectedSubCategoryTagMapId").val(subCategoryTagMapId);
        $("#productItemSelections").removeClass("hidden");

        // Set CSS classes to selectedProduct and unSelectedProduct
        $(".categoryCard").each(function () {
          var currentlyCategoryId = $(this).attr("data-categoryId");

          if (currentlyCategoryId == categoryId) {
            $(this).addClass("selectedProduct");
            $(this).removeClass("unSelectedProduct");
          } else {
            $(this).removeClass("selectedProduct");
            $(this).addClass("unSelectedProduct");
          }
        });

        // Scroll to the product info section
        $("html,body").animate({
          scrollTop: $("#productItemSelections").offset().top - 25
        }, "slow");

      }
    });

    // Handle input for the description box
    $("#valItemDescription").on("change, keyup", function () {

      const value = $(this).val();
      var output = null;

      if (value) {
        const length = value.length;
        output = "(" + length + " character" + (length > 1 ? "s" : "") + ")";
      }

      $("#descriptionLengthCont").html(output);
    });

    // Handle not enough description dialog confirm
    $("body").on("click", "#notEnoughDescriptionDlg .btn-ok", function () {
      $("#notEnoughDescriptionDlg").modal("hide");
      TECL_TenderSimpleProductSelection.ContinueToNextStageServerCall();
    });
  },

  // Continue to the next stage
  ContinueToNextStage: function () {
    if (TECL_TenderSimpleProductSelection.ValidatePage()) {
      TECL_TenderSimpleProductSelection.ContinueToNextStageServerCall();
    }
  },

  /*
   * The actual server call to continue to the next stage
   */
  ContinueToNextStageServerCall: function() {
    var cacheId = $("#cacheId").val();
    var data = TECL_TenderSimpleProductSelection.SerialisedData();

    if (TECL_Master.AddLock("ContinueNextStageQuoteDuration")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      // Call Server to add the product request to the cache and reload the product request list
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageQuoteDurationFromSimpleItemSelector",
        type: "POST",
        data: {
          cacheId: cacheId,
          data: data
        },
        error: function (exc) {
          TECL_Master.ClearLock("ContinueNextStageQuoteDuration");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("ContinueNextStageQuoteDuration");
          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);
          }
        }
      });
    }
  },

  // Vaidate the page
  ValidatePage: function () {
    $("#errNoCategorySelected").addClass("hidden");
    $("#errItemName").addClass("hidden");
    $("#errItemDescription").addClass("hidden");

    var noErrors = true;

    var caregoryId = $("#selectedCategoryId").val();
    if (!caregoryId) {
      noErrors = false;
      $("#errNoCategorySelected").removeClass("hidden");
    }

    var itemName = $("#valItemName").val();
    if (!itemName) {
      noErrors = false;
      $("#errItemName").removeClass("hidden");
    }

    var description = $("#valItemDescription").val();
    if (!description || description.length < 0) {

      noErrors = false;
      $("#errItemDescription").removeClass("hidden");
    } else if (description.length < 100 && noErrors) {

      noErrors = false;
      $("#notEnoughDescriptionDlg").modal("show");
    }

    return noErrors;
  },

  // Get the Serialised Data
  SerialisedData: function () {
    var categoryId = $("#selectedCategoryId").val();
    var categoryName = $("#selectedCategoryName").val();
    var subCategoryId = $("#selectedSubCategoryId").val();
    var subCategoryTagMapId = $("#selectedSubCategoryTagMapId").val();
    var tenderName = $("#valItemName").val();
    var description = $("#valItemDescription").val();

    // Get the budegt value
    var $budgetDropDown = $("#valItemBudget");
    var budget = $budgetDropDown.data("kendoDropDownList").value();
    if (budget.length <= 0) {
      budget = "0";
    } else {
      budget = budget.replace(",", "");
      budget = budget.replace("< ", "");
    }
    // Ensure we have a number
    var parsedBudget = parseInt(budget);
    if (Number.isNaN(parsedBudget)) {
      budget = "0";
    }

    var data = {
      CategoryId: categoryId,
      CategoryName: categoryName,
      SubCategoryId: subCategoryId,
      SubCategoryTagMapId: subCategoryTagMapId,
      TenderName: tenderName,
      Budget: budget,
      Description: description
    }
    return data;
  }

};